module.exports = __webpack_public_path__ + "static/media/zip.8852b59f.svg";